/* global axios */
import ApiClient from './ApiClient';

// Fluxos que já rodaram numa conversa ou para um contato, com a versão de cada
// execução (#1705). Os dois endpoints moram embaixo do recurso dono da tela —
// é a permissão de ver a conversa/o contato que libera a listagem.
// Devolvem { meta: { count, current_page, per_page }, payload }. O tamanho da
// página é do servidor (5 hoje) e vem em `meta.per_page` — quem pagina lê dali.
class AutomationFlowSessionsAPI extends ApiClient {
  constructor() {
    super('', { accountScoped: true });
  }

  byConversation(conversationId, { page } = {}) {
    return axios.get(
      `${this.baseUrl()}/conversations/${conversationId}/automation_flow_sessions`,
      { params: { page } }
    );
  }

  byContact(contactId, { page } = {}) {
    return axios.get(
      `${this.baseUrl()}/contacts/${contactId}/automation_flow_sessions`,
      { params: { page } }
    );
  }
}

export default new AutomationFlowSessionsAPI();
